module.exports = __webpack_public_path__ + "static/media/1.2c08d4af.png";